import appConstants from "../../../../../../appConstants";
import { NumericEditor } from "../../../../../dataGrid/cellEditors";
export default class GridConfig {
    constructor(configuration){
        const config = configuration || {};
        this.name = "GridConfiguration";
        this.config = GridConfig.getConfiguration(config);
    }
    static getConfiguration(config) {
      return GridConfig.getDefaultConfiguration();
    }

    static getDefaultConfiguration() {
    return {
      title: appConstants.gridNames.StemMiles,
      keyColumn: "stemSpeedProfileId",
      enableFilters: false,
      enableSorting: false,
      columns: [
        {
          headerName: "Stem Mile ID",
          field: "stemSpeedProfileId",
          hide: true,
          headerTooltip: "Stem Mile ID"
        },
        {
          headerName: "Stem Miles",
          headerTooltip: "Stem Miles",
          valueFormatter: params => `${params.data.lowerRangeMile.toString()} - ${params.data.higherRangeMile.toString()}`,
          minWidth: appConstants.columnWidth.SPEED_MILES_RANGE
        },
        {
          headerName: "Speed (Miles/hour)",
          field: "stemSpeed",
          headerTooltip: "Speed",
          minWidth:200,
          editable: true,
          cellEditorFramework: NumericEditor
        }
      ]
    }
  }
}